module.exports = __webpack_public_path__ + "img/placeholder.12d0fc49.png";